/* <two-rituals> - interactive cast-iron vs. aluminium care animation.
   Self-registering custom element. Light DOM so it inherits page fonts
   (Anton / Work Sans / Playfair Display). Scoped under .pr- classes.
   Colours tweaked to Potties brand: --orange #D9691E, --dark #232729. */
(function(){
  if (window.customElements && customElements.get('two-rituals')) return;

  var STYLE_ID = 'pr-styles';
  var CSS = `
    .pr-root{--cream:#E2D5BC;--panel:#EBE0CF;--dark:#211F1C;--orange:#D9691E;--ink:#26241F;--muted:#6E665B;--ironink:#3A2614;
      font-family:'Work Sans',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;color:var(--ink);display:block;}
    .pr-root *,.pr-root *::before,.pr-root *::after{box-sizing:border-box;}
    .pr-controls{display:flex;justify-content:center;align-items:center;gap:12px;margin:0 0 30px;flex-wrap:wrap;}
    .pr-hint{font-size:14px;color:var(--muted);}
    .pr-btn{font-family:inherit;font-size:15px;font-weight:700;letter-spacing:.02em;cursor:pointer;border-radius:999px;
      padding:13px 26px;border:none;display:inline-flex;align-items:center;gap:9px;transition:transform .15s ease,background .2s ease,opacity .2s ease;}
    .pr-btn:active{transform:scale(.97);}
    .pr-btn-go{background:var(--orange);color:#fff;}
    .pr-btn-go:hover{background:#a85201;}
    .pr-btn-replay{background:transparent;color:var(--ink);border:1px solid #C9BCA8;}
    .pr-btn-replay:hover{border-color:var(--ink);}
    .pr-btn-replay[hidden]{display:none;}
    .pr-grid{display:grid;grid-template-columns:1fr 1fr;gap:28px;align-items:stretch;}
    @media(max-width:760px){.pr-grid{grid-template-columns:1fr;}}
    .pr-card{display:flex;flex-direction:column;border-radius:10px;overflow:hidden;position:relative;}
    .pr-alu{order:1;background:#fff;border:1px solid #EADFCE;box-shadow:0 14px 30px rgba(120,90,40,.08);}
    .pr-iron{order:2;background:linear-gradient(155deg,#C9A35B 0%,#BE9447 55%,#A87E38 100%);color:var(--ironink);
      border:1px solid #8E6B2C;box-shadow:inset 0 0 90px rgba(74,48,16,.4),0 14px 30px rgba(74,48,16,.18);}
    .pr-iron::before{content:"";position:absolute;inset:0;background:radial-gradient(circle at 30% 18%,rgba(255,255,255,.14),transparent 60%);pointer-events:none;}
    .pr-in{position:relative;flex:1;display:flex;flex-direction:column;padding:32px 30px;}
    .pr-cardhead{display:flex;align-items:center;justify-content:space-between;padding-bottom:16px;}
    .pr-alu .pr-cardhead{border-bottom:2px solid #F0E6D6;}
    .pr-iron .pr-cardhead{border-bottom:2px solid rgba(58,38,20,.35);}
    .pr-tag{font-size:11px;font-weight:700;letter-spacing:.2em;text-transform:uppercase;}
    .pr-alu .pr-tag{color:var(--orange);}
    .pr-iron .pr-tag{color:#6B4A22;}
    .pr-title{font-family:'Anton',sans-serif;font-weight:400;font-size:32px;line-height:1;margin-top:6px;text-transform:uppercase;}
    .pr-iron .pr-title{font-family:'Playfair Display',serif;font-weight:700;text-transform:none;font-size:33px;}
    .pr-emoji{font-size:38px;line-height:1;}
    .pr-iron .pr-emoji{font-family:'Playfair Display',serif;font-style:italic;color:rgba(58,38,20,.45);}
    .pr-meter{margin:20px 0 4px;}
    .pr-meter-top{display:flex;align-items:baseline;justify-content:space-between;margin-bottom:8px;}
    .pr-meter-label{font-size:11px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#9A9080;}
    .pr-iron .pr-meter-label{color:#6B4A22;}
    .pr-clock{font-family:'Anton',sans-serif;font-size:28px;line-height:1;}
    .pr-alu .pr-clock{color:var(--orange);}
    .pr-iron .pr-clock{color:var(--ironink);}
    .pr-bar{height:10px;border-radius:999px;overflow:hidden;}
    .pr-alu .pr-bar{background:#E2D5BC;}
    .pr-iron .pr-bar{background:rgba(58,38,20,.18);}
    .pr-fill{height:100%;width:0;border-radius:999px;transition:width .6s cubic-bezier(.4,0,.2,1);}
    .pr-bar .pr-fill{display:block;} /* override base.css div:empty{display:none}, which hides the empty fill div */
    .pr-alu .pr-fill{background:linear-gradient(90deg,#E58A3F,var(--orange));}
    .pr-iron .pr-fill{background:linear-gradient(90deg,#7A5526,#4A300F);}
    .pr-list{margin:20px 0 0;flex:1;}
    .pr-subhead{font-family:'Playfair Display',serif;font-style:italic;font-size:15px;color:#5A3D1C;margin:14px 0 4px;}
    .pr-subhead.pr-first{margin-top:4px;}
    .pr-rev{opacity:1;transform:none;transition:opacity .5s ease,transform .5s ease;}
    .pr-root.pr-armed .pr-rev{opacity:0;transform:translateY(8px);}
    .pr-root.pr-armed .pr-rev.pr-on{opacity:1;transform:translateY(0);}
    .pr-step{display:flex;gap:13px;align-items:flex-start;padding:11px 0;}
    .pr-alu .pr-step{border-bottom:1px solid #E2D5BC;}
    .pr-iron .pr-step{border-bottom:1px dashed rgba(58,38,20,.25);}
    .pr-num{flex-shrink:0;display:flex;align-items:center;justify-content:center;font-family:'Anton',sans-serif;}
    .pr-alu .pr-num{width:34px;height:34px;border-radius:50%;background:var(--orange);color:#fff;font-size:16px;}
    .pr-iron .pr-num{width:24px;font-family:'Playfair Display',serif;font-weight:700;font-size:19px;color:#6B4A22;line-height:1.2;}
    .pr-st-t{display:block;font-size:15px;line-height:1.45;font-weight:600;}
    .pr-iron .pr-st-t{font-weight:500;font-size:14.5px;}
    .pr-st-d{display:block;font-size:13px;line-height:1.45;color:var(--muted);font-weight:400;margin-top:2px;}
    .pr-chips{display:flex;gap:8px;flex-wrap:wrap;margin-top:20px;}
    .pr-chip{font-size:12px;font-weight:600;color:#3A352D;background:#E2D5BC;border-radius:999px;padding:7px 13px;}
    .pr-footwrap{margin-top:auto;padding-top:20px;}
    .pr-foot-banner{border-radius:6px;padding:15px 18px;text-align:center;font-weight:700;font-size:16px;}
    .pr-alu .pr-foot-banner{background:var(--dark);color:var(--cream);}
    .pr-alu .pr-foot-banner b{color:var(--orange);}
    .pr-iron .pr-foot-banner{background:rgba(58,38,20,.14);border:1px solid rgba(58,38,20,.3);color:#4A300F;font-family:'Playfair Display',serif;font-style:italic;font-weight:500;}
    .pr-pulse{animation:pr-pulse 1.1s ease-in-out infinite;}
    @keyframes pr-pulse{0%,100%{box-shadow:0 0 0 0 rgba(196,100,1,0);}50%{box-shadow:0 0 0 6px rgba(196,100,1,.16);}}
    @media (prefers-reduced-motion: reduce){
      .pr-root.pr-armed .pr-rev{opacity:1 !important;transform:none !important;}
      .pr-fill{transition:none !important;} .pr-pulse{animation:none !important;}
    }
  `;

  function injectStyle(){
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID; s.textContent = CSS;
    document.head.appendChild(s);
  }

  var ALU = [
    { n:'1', t:'Unbox &amp; rinse', d:'Warm water, a drop of soap. Steel wool is fine.' },
    { n:'2', t:'Towel dry',        d:'No curing, no newspaper, no oil to store.' },
    { n:'3', t:'Start cooking',    d:'Less likely to stick and rust-proof, straight out the box.' },
  ];
  var IRON = [
    { head:'Before you can even cook -' },
    { n:'1', t:'Burn off the lacquer', d:'Over an open flame, inside and out.' },
    { n:'2', t:'Scour with steel wool', d:'Down to bare metal, every surface.' },
    { n:'3', t:'Boil with peels &times;5', d:'Draw the rust out, again and again.' },
    { n:'4', t:'Season with fatty mutton', d:'Boiled in salted water. Twice.' },
    { head:'After every single meal -' },
    { n:'5', t:'Wash &amp; never leave wet', d:'Standing water starts the rust.' },
    { n:'6', t:'Dry over heat', d:'So the damp can never settle in.' },
    { n:'7', t:'Re-oil the inside', d:'A fresh coat, every single time.' },
    { n:'8', t:'Store oiled, check often', d:'Rust waits for the one time you forget.' },
  ];

  function ironRows(){
    var first = true; var html = '';
    IRON.forEach(function(r){
      if (r.head){ html += '<div class="pr-rev pr-subhead'+(first?' pr-first':'')+'">'+r.head+'</div>'; first=false; }
      else { html += '<div class="pr-rev pr-step"><span class="pr-num">'+r.n+'</span><span><span class="pr-st-t">'+r.t+'</span><span class="pr-st-d">'+r.d+'</span></span></div>'; }
    });
    return html;
  }
  function aluRows(){
    return ALU.map(function(r){
      return '<div class="pr-rev pr-step"><span class="pr-num">'+r.n+'</span><span><span class="pr-st-t">'+r.t+'</span><span class="pr-st-d">'+r.d+'</span></span></div>';
    }).join('');
  }

  var TwoRituals = function(){};
  TwoRituals = class extends HTMLElement {
    connectedCallback(){
      if (this._init) return; this._init = true;
      injectStyle();
      this.innerHTML =
        '<div class="pr-root pr-armed">'+
          '<div class="pr-controls">'+
            '<button class="pr-btn pr-btn-go" data-go>&#9654;&nbsp; Watch them cook</button>'+
          '</div>'+
          '<div class="pr-grid">'+
            '<div class="pr-card pr-alu"><div class="pr-in">'+
              '<div class="pr-cardhead"><div><div class="pr-tag">The Potties way</div><div class="pr-title">Wash. Dry. Done.</div></div></div>'+
              '<div class="pr-meter"><div class="pr-meter-top"><span class="pr-meter-label">Before you can cook</span><span class="pr-clock" data-clock="alu">0 min</span></div><div class="pr-bar"><div class="pr-fill" data-fill="alu"></div></div></div>'+
              '<div class="pr-list" data-list="alu">'+aluRows()+'</div>'+
              '<div class="pr-chips">'+
                '<span class="pr-chip">Less likely to stick</span><span class="pr-chip">Steel-wool safe</span><span class="pr-chip">No old oil taste</span><span class="pr-chip">Lifetime warranty</span>'+
              '</div>'+
              '<div class="pr-footwrap"><div class="pr-rev pr-foot-banner" data-result="alu">On the fire in under a minute. <b>Just cook.</b></div></div>'+
            '</div></div>'+
            '<div class="pr-card pr-iron"><div class="pr-in">'+
              '<div class="pr-cardhead"><div><div class="pr-tag">The cast-iron way</div><div class="pr-title">Die Ou Manier</div></div></div>'+
              '<div class="pr-meter"><div class="pr-meter-top"><span class="pr-meter-label">Before you can cook</span><span class="pr-clock" data-clock="iron">0 min</span></div><div class="pr-bar"><div class="pr-fill" data-fill="iron"></div></div></div>'+
              '<div class="pr-list" data-list="iron">'+ironRows()+'</div>'+
              '<div class="pr-footwrap"><div class="pr-rev pr-foot-banner" data-result="iron">&ldquo;Miss a step, and the rust wins.&rdquo;</div></div>'+
            '</div></div>'+
          '</div>'+
        '</div>';
      this._wire();
    }

    _wire(){
      var root = this.querySelector('.pr-root');
      var go = this.querySelector('[data-go]');
      var aluRev = this.querySelectorAll('[data-list="alu"] .pr-rev');
      var ironRev = this.querySelectorAll('[data-list="iron"] .pr-rev');
      var aluResult = this.querySelector('[data-result="alu"]');
      var ironResult = this.querySelector('[data-result="iron"]');
      var aluClock = this.querySelector('[data-clock="alu"]');
      var ironClock = this.querySelector('[data-clock="iron"]');
      var aluFill = this.querySelector('[data-fill="alu"]');
      var ironFill = this.querySelector('[data-fill="iron"]');
      var timers = [], rafs = [], running = false;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function clearAll(){ timers.forEach(clearTimeout); timers=[]; rafs.forEach(cancelAnimationFrame); rafs=[]; }
      function at(ms, fn){ timers.push(setTimeout(fn, ms)); }
      function fmt(min){ if(min<60) return Math.round(min)+' min'; var h=Math.floor(min/60), m=Math.round(min%60); return h+' hr'+(h>1?'s':'')+(m?' '+m+'m':''); }
      function count(el, target, dur){ var start=performance.now(); function tick(now){ var p=Math.min(1,(now-start)/dur); var e=1-Math.pow(1-p,3); el.textContent=fmt(target*e); if(p<1) rafs.push(requestAnimationFrame(tick)); } rafs.push(requestAnimationFrame(tick)); }
      function reset(){
        clearAll(); running=false; root.classList.add('pr-armed');
        [].forEach.call(aluRev,function(s){s.classList.remove('pr-on');});
        [].forEach.call(ironRev,function(s){s.classList.remove('pr-on');});
        ironFill.classList.remove('pr-pulse');
        aluFill.style.transition='none'; ironFill.style.transition='none';
        aluFill.style.width='0'; ironFill.style.width='0';
        void ironFill.offsetWidth;
        aluFill.style.transition=''; ironFill.style.transition='';
        aluClock.textContent='0 min'; ironClock.textContent='0 min';
      }
      function finishUI(){ go.textContent='▶  Watch them cook'; go.style.opacity='1'; running=false; }

      function play(){
        if(running) return; reset(); running=true;
        go.textContent='▶  Cooking…'; go.style.opacity='.6';

        if(reduce){
          [].forEach.call(aluRev,function(s){s.classList.add('pr-on');});
          [].forEach.call(ironRev,function(s){s.classList.add('pr-on');});
          aluFill.style.transition='none'; ironFill.style.transition='none';
          aluFill.style.width='9%'; ironFill.style.width='100%';
          aluClock.textContent=fmt(1); ironClock.textContent=fmt(185);
          finishUI(); return;
        }

        var aGap = 820;
        at(150, function(){ aluFill.style.width='9%'; count(aluClock,1,2100); });
        [].forEach.call(aluRev, function(s,i){ at(150 + i*aGap, function(){ s.classList.add('pr-on'); }); });
        var aDone = 150 + aluRev.length*aGap;
        at(aDone + 200, function(){ aluResult.classList.add('pr-on'); });

        var iStart = aDone + 650, iGap = 430;
        ironFill.style.transition = 'width ' + ((ironRev.length*iGap)/1000) + 's linear';
        at(iStart-100, function(){ ironFill.style.width='100%'; count(ironClock,185,ironRev.length*iGap); });
        [].forEach.call(ironRev, function(s,i){ at(iStart + i*iGap, function(){ s.classList.add('pr-on'); }); });
        at(iStart + ironRev.length*iGap + 250, function(){ ironResult.classList.add('pr-on'); ironFill.classList.add('pr-pulse'); finishUI(); });
      }

      go.addEventListener('click', play);

      if('IntersectionObserver' in window){
        var self = this;
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(en){ if(en.isIntersecting){ play(); io.disconnect(); } });
        }, { threshold:.12, rootMargin: '0px 0px -10% 0px' });
        io.observe(this);
        // fallback: if it never scrolls into the observed threshold, arm a one-time scroll trigger
        var armed = false;
        window.addEventListener('scroll', function onScroll(){
          if(armed) return;
          var r = self.getBoundingClientRect();
          if(r.top < window.innerHeight*0.85 && r.bottom > 0){ armed = true; play(); window.removeEventListener('scroll', onScroll); }
        }, { passive:true });
      }
    }
  };

  customElements.define('two-rituals', TwoRituals);
})();
